import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../classes/tradePlan/tradePlanProvider';
import { OptionChainsTableRow } from './OptionChainsTableRow';
import { OptionData } from './optionType';

export const OptionChainsCalls = observer(() => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const optionManagement = tradePlanForm.optionManagement;
  const selectedCalls = optionManagement.selectedOptions.calls;

  return (
    <>
      {selectedCalls.map((call: OptionData) => (
        <OptionChainsTableRow key={call.symbol} type="Call" data={call} />
      ))}
    </>
  );
});
